//useRequiredDocumentTemplatesQuery
import { useQuery } from 'react-query';

import { Guid } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';
import { LoanApplicationTaskTemplate } from '../../models/LoanApplicationTask';

export function useRequiredDocumentTemplatesQuery() {
	const api = useApi();

	return useQuery(QueryKeys.RequiredDocuments.Templates(), () =>
		AxiosUtils.getResponseData<LoanApplicationTaskTemplate[]>(
			api.get(CerebroApiEndpoints.RequiredDocuments.Templates())
		)
	);
}
